import type { PromptTemplateId } from '../types';
import slugBatch from './defaults/slug_batch.md?raw';
import outlineGen from './defaults/outline_gen.md?raw';
import outlineRevise from './defaults/outline_revise.md?raw';
import proseGen from './defaults/prose_gen.md?raw';
import proseRevise from './defaults/prose_revise.md?raw';
import storyBible from './defaults/story_bible.md?raw';
import voiceConfig from './defaults/voice_config.md?raw';
import canonUpdate from './defaults/canon_update.md?raw';

export const DEFAULTS: Record<PromptTemplateId, string> = {
  slug_batch: slugBatch,
  outline_gen: outlineGen,
  outline_revise: outlineRevise,
  prose_gen: proseGen,
  prose_revise: proseRevise,
  story_bible: storyBible,
  voice_config: voiceConfig,
  canon_update: canonUpdate,
};

export const TEMPLATE_DESCRIPTIONS: Record<PromptTemplateId, string> = {
  slug_batch: 'Generate a batch of story slug candidates.',
  outline_gen: 'Expand a slug into a 5–7 beat outline.',
  outline_revise: 'Revise an outline per freeform notes.',
  prose_gen: 'Expand an approved outline into full read-aloud prose.',
  prose_revise: 'Revise finished prose per freeform notes.',
  story_bible: 'World and character bible injected as system context on every stage.',
  voice_config: 'Narration cues for TTS-readable prose style.',
  canon_update: 'Background extractor: updates the universe canon after each prose.',
};

export const TEMPLATE_ORDER: PromptTemplateId[] = [
  'story_bible',
  'voice_config',
  'slug_batch',
  'outline_gen',
  'outline_revise',
  'prose_gen',
  'prose_revise',
  'canon_update',
];

type Lookup = (id: PromptTemplateId, universeId?: string) => string | undefined;

let overridesLookup: Lookup = () => undefined;
let extensionsLookup: Lookup = () => undefined;

export function setOverridesLookup(fn: Lookup) {
  overridesLookup = fn;
}

export function setExtensionsLookup(fn: Lookup) {
  extensionsLookup = fn;
}

export function getTemplate(id: PromptTemplateId, universeId?: string): string {
  const base = overridesLookup(id, universeId) ?? DEFAULTS[id];
  const ext = extensionsLookup(id, universeId)?.trim();
  return ext ? `${base}\n\n${ext}` : base;
}

export function getDefault(id: PromptTemplateId): string {
  return DEFAULTS[id];
}
